module.exports = __webpack_public_path__ + "static/images/btn-tiger.38442f7.png";